import { render, staticRenderFns } from "./OrganizationUserProfile.vue?vue&type=template&id=31815197&scoped=true&"
import script from "./OrganizationUserProfile.vue?vue&type=script&lang=js&"
export * from "./OrganizationUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationUserProfile.vue?vue&type=style&index=0&id=31815197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31815197",
  null
  
)

export default component.exports